import { render, staticRenderFns } from "./RateHistory.vue?vue&type=template&id=16b9742e&scoped=true"
import script from "./RateHistory.vue?vue&type=script&lang=js"
export * from "./RateHistory.vue?vue&type=script&lang=js"
import style0 from "./RateHistory.vue?vue&type=style&index=0&id=16b9742e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b9742e",
  null
  
)

export default component.exports